import moment from "moment";
import Icon from "@mdi/react";
import { mdiCalendar, mdiPen } from "@mdi/js";
import { useState } from "react";
import { Link, useTitle } from "easy-page-router/react";

import { useHeaders, useSSRHook } from "../../ssrh/client";
import { useUser } from "../User";
import { Header, Loading, Separator } from "../components";
import EditNew from "../components/EditNew";

import { New } from "../../types";
import Footer from "../components/Footer";

export default function New({ id }: { id: string }) {
    const user = useUser();

    const [news, error, isLoading, reload] = useSSRHook<New>(`/api/new?id=${encodeURIComponent(id)}`);
    const h1 = news?.title ?? "Aktualita";

    const title = h1 + " | TSO Krkonoše";
    useTitle(title);
    useHeaders({
        title,
        description: news?.content.slice(0, 150) ?? "Aktualita | TSO Krkonoše",
        image: window.location.origin + "/logo.png",
        canonical: window.location.origin + window.location.pathname,
    });

    const [edit, setEdit] = useState<null | New>(null);

    return (
        <>
            <main>
                <Header background="papers" title="Aktualita">
                    <Link to="/">Aktuality</Link>
                    <span className="space">-</span>
                    {h1}
                </Header>
                <div className="content">
                    <section>
                        <div className="page">
                            {isLoading && <Loading />}
                            {error && (
                                <p className="alert">
                                    Aktuality se bohužel nepodařili načíst 🙁
                                </p>
                            )}

                            {news && (
                                <>
                                    {user.isAdmin && (
                                        <div className="admin">
                                            <button onClick={() => setEdit(news)}>
                                                <Icon path={mdiPen} size={1} />{" "}
                                                Upravit aktualitu
                                            </button>
                                            <EditNew
                                                value={edit}
                                                onClose={() => setEdit(null)}
                                                onChange={() => {
                                                    reload();
                                                    setEdit(null);
                                                }}
                                            />
                                        </div>
                                    )}

                                    <h1>{news.title}</h1>
                                    <Separator />
                                    <div className="title-date">
                                        <Icon path={mdiCalendar} size={1} />{" "}
                                        {moment(news.date).format("LL")}
                                    </div>
                                    <p className="pre">{news.content}</p>
                                </>
                            )}
                        </div>
                    </section>
                </div>
            </main>
            <Footer />
        </>
    );
}
